export default "__VITE_ASSET__6f2a56d7__"